import { detectMob, datasetOfDatasetQuery } from '../assets/utils.js'
import frel from '../assets/frel.js'
import Tabs from '../assets/tabs.js'

const tabContainer = '[data-tab-container]'
const tabs = '[data-reveal-tab]'
const activeClass = 'active'
const targetContainer = '[data-tab-content-container]'
const targets = '[data-card-group]'
const targetActiveClass = 'active'

const sliderConfig = {
    slidesPerView: 1,
    spaceBetween: 10,
    navigation: {
        nextEl: '[data--rewards-swiper-navigation-right]',
        prevEl: '[data-rewards-swiper-navigation-left]',
    }, pagination: {
        el: '[data-rewards-swiper-pagination]',
        clickable: true,
        type: 'custom',
        renderCustom(_, current, total) {
            return (`
                      ${current}/${total}
                  `)
        }
    },
    breakpoints: {
        750: {
            slidesPerView: 2,
            spaceBetween: 20
        },
        1000: {
            slidesPerView: 4,
            spaceBetween: 20
        }
    }
}

const generateProductImage = (src) => {
    const img = frel('img', { class: 'rewards-redeem_product-image' })
    img.src = src
    return img
}

const generateDetailsOpener = (i) => {
    return frel('p', { class: 'rewards-redeem_product-description reward-toggle-show' + i, onclick: 'toggleDetails(true, ' + i + ');' }, 'Details')
}

const generateDetailsCloser = (i) => {
    return frel('p', { class: 'rewards-redeem_product-closer reward-toggle-hide' + i, onclick: 'toggleDetails(false, ' + i + ');' }, 'Close details')
}

const generateDetailsBody = (description, i) => {
    return frel('p', { class: 'rewards-redeem_product-body reward-toggle-body' + i }, description)
}

const generateProductTitle = (name) => {
    return frel('p', { class: 'rewards-redeem_product-title' }, name)
}

const generateProductPointCost = (costText) => {
    return frel('p', { class: 'rewards-redeem_product-point-cost' }, costText)
}

const generateLoginButton = () => {
    const anchorElement = frel('a', { class: 'rewards-redeem_product-login-button' }, 'login')
    anchorElement.href = '/account/login'
    return anchorElement
}

const generateRedeemButton = (variantId) => {
    const anchorElement = frel('a', { class: 'rewards-redeem_product-redeem-button swell-buy-product-btn' }, 'add to bag')
    anchorElement.dataset.variantId = variantId
    anchorElement.dataset.errorContent = 'Looks like you need more points to redeem this item. Points needed: *|amount|* pts<br>You have: *|point_balance|* pts'
    anchorElement.dataset.successContent = 'Item added to bag.'
    anchorElement.dataset.errorTitle = 'Sorry'
    anchorElement.dataset.successTitle = 'Hooray!'
    anchorElement.dataset.cancelBtnText = 'NEVER MIND'
    anchorElement.dataset.confirmContent = 'Just checking! You currently have *|point_balance|* points available. This product costs *|amount|* points to redeem.'
    return anchorElement
}

const generateProductCardElement = () => {
    return frel('div', { class: 'rewards-redeem_product-card swiper-slide' })
}

const generateProductCardInnerWrapper = () => {
    return frel('div', { class: 'rewards-redeem_product-card-inner-wrapper' })
}

const loggedInCheck = () => {
    const value = datasetOfDatasetQuery('logged-in-state')
    return value === 'true'
}

const getCart = async () => {
    const result = await fetch('/cart.js')
    const json = await result.json()
    return json
}

// Main class
class RewardsRedeem extends HTMLElement {
    constructor() {
        super()
        this.productCards = []
        this.swiperInstance = {}
        this.init()
    }

    query(selector) {
        return this.querySelector(selector)
    }

    inject(selector, element) {
        this.query(selector).appendChild(element)
    }



    filterDisplayByGroup(group) {
        this.productCards.forEach((productCard) => {
            const thisCardGroup = productCard.dataset?.cardGroup
            if (thisCardGroup === group) {
                productCard.style.display = 'flex'
            } else {
                productCard.style.display = 'none'
            }
        })
    }

    initProductCards() {
        if (spapi) {
            spapi.setupBuyProductWithPointsHelper()
        }
        swellAPI.refreshEmbeds()
    }

    initRedeemSucess() {
        window.onBeforeProductRedemption = async (opts, redemptionOption, pointBalance, cb) => {
            console.log('onBeforeProductRedemption', opts, redemptionOption, pointBalance, cb)
            const cart = await getCart()
            if (cart.items_subtotal_price < 1) {
                spapi.$.confirm({
                    title: "Oops!",
                  content: "You can only redeem points for a free product when making a purchase.",
                  type: "red",
                  typeAnimated: true,
                  useBootstrap: false,
                  boxWidth: "400px",
                  buttons: {
                    ok: {
                      text: "Ok",
                      action: function () {
                      }
                    }
                  }
                });
            } else {
                cb()
            }
        }

        document.addEventListener('swell:redemption', redemption => {
        
        })
    }

    initTabButtons() {
        const tabsInstance = new Tabs({
            tabContainer,
            tabs,
            activeClass,
            targetContainer,
            targets,
            targetActiveClass,
            funcSettings: {
                beforeTargetClassAdded: (_, tab) => {
                    const group = tab.dataset?.targetGroup
                    const sliderControls = document.querySelector('[data-rewards-swiper-pagination]')
                    this.destroySlider()
                    this.filterDisplayByGroup(group)
                    this.initSlider()
                    sliderControls.style.display = 'none'
                    const visibleProductCards = document.querySelectorAll('[data-card-group]:not([style*="display: none"])')
                    if (detectMob() && visibleProductCards.length > 1) {
                        sliderControls.style.display = 'flex'
                    } else if (visibleProductCards.length > 4) {
                        sliderControls.style.display = 'flex'
                    }
                    // return true to stop the target class from being added
                    return true
                }
            }
        })
    }

    async renderProductCard(data, group, i) {
        const { name, appliesToId, costText, description, backgroundImageUrl } = data || {}
        const nameElement = generateProductTitle(name)
        const pointCostElement = generateProductPointCost(costText)
        const imageElement = generateProductImage(backgroundImageUrl)
        const redeemButtonElement = generateRedeemButton(appliesToId)
        const descriptionOpener = generateDetailsOpener(i)
        const descriptionCloser = generateDetailsCloser(i)
        const descriptionBody = generateDetailsBody(description, i)
        const loginButtonElement = generateLoginButton()
        const productCardElelment = generateProductCardElement()
        const productCardInnerWrapper = generateProductCardInnerWrapper()
        productCardInnerWrapper.appendChild(imageElement)
        productCardInnerWrapper.appendChild(nameElement)
        productCardInnerWrapper.appendChild(descriptionOpener)
        productCardInnerWrapper.appendChild(descriptionBody)
        productCardInnerWrapper.appendChild(descriptionCloser)
        productCardInnerWrapper.appendChild(pointCostElement)
        if (loggedInCheck()) {
            productCardInnerWrapper.appendChild(redeemButtonElement)
        } else {
            productCardInnerWrapper.appendChild(loginButtonElement)
        }
        productCardElelment.appendChild(productCardInnerWrapper)
        productCardElelment.dataset.cardGroup = group
        this.inject('[data-card-group-container]', productCardElelment)
        this.productCards.push(productCardElelment)
    }

    renderProductCards() {
        var i = 0;
        Object.keys(this.redemptionProductsSorted).forEach(async (key) => {
            const pointProductsArray = this.redemptionProductsSorted[key]
            pointProductsArray.forEach(pointProduct => {
                i = i + 1;
                this.renderProductCard(pointProduct, key, i);
            })
            this.filterDisplayByGroup('oneHundred')
        })
    }

    initSlider() {
        this.swiperInstance = new Swiper('[data-rewards-redeem-slider]', sliderConfig)
    }

    destroySlider() {
        if (this.swiperInstance) {
            this.swiperInstance.destroy(true, true)
        }
    }

    swellVariablesInit() {
        this.activeRedemptionOptions = swellAPI.getActiveRedemptionOptions()
        this.redemptionProducts = this.activeRedemptionOptions.filter(redemptionOption => {
            return redemptionOption.discountType === 'product'
        })
        this.hundredPointRedemptionPoints = this.redemptionProducts.filter(redemptionProduct => {
            return redemptionProduct.costInPoints === 100
        })
        this.twoHundredPointRedemptionPoints = this.redemptionProducts.filter(redemptionProduct => {
            return redemptionProduct.costInPoints === 200
        })
        this.fiveHundredPointRedemptionPoints = this.redemptionProducts.filter(redemptionProduct => {
            return redemptionProduct.costInPoints === 500
        })
        this.oneThousandPointRedemptionPoints = this.redemptionProducts.filter(redemptionProduct => {
            return redemptionProduct.costInPoints === 1000
        })
        this.redemptionProductsSorted = {
            oneHundred: this.hundredPointRedemptionPoints,
            twoHundred: this.twoHundredPointRedemptionPoints,
            fiveHundred: this.fiveHundredPointRedemptionPoints,
            oneThousand: this.oneThousandPointRedemptionPoints
        }
    }

    initListeners() {
        document.addEventListener('swell:setup', () => {
            this.swellVariablesInit()
            this.renderProductCards()
            this.initSlider()
            this.initTabButtons()
            this.initProductCards()
            this.initRedeemSucess()
        })
    }

    init() {
        this.initListeners()
    }
}

customElements.define('rewards-redeem', RewardsRedeem)